import ENVIRONMENT, { Environment } from './environment';
import { AppName, createDebugLogger } from './logging';
const logger = createDebugLogger(AppName.Common);
if (!window.dataLayer) {
  if (ENVIRONMENT !== Environment.Production) {
    logger.log('It seems that window.dataLayer is not initialized. Please make sure GTM is installed properly.');
  }
  window.dataLayer = window.dataLayer || [];
}
export let GtmEvent = function (GtmEvent) {
  GtmEvent["UserLoggedIn"] = "user.loggedin";
  GtmEvent["UserLoggedOut"] = "user.loggedout";
  GtmEvent["GoogleLoginFailed"] = "auth.google_login_failed";
  GtmEvent["LocaleChanged"] = "locale.changed";
  GtmEvent["ApplicationStarted"] = "application.started";
  GtmEvent["ApplicationResumed"] = "application.resumed";
  GtmEvent["ApplicationSaved"] = "application.saved";
  GtmEvent["ApplicationPostponed"] = "application.postponed";
  GtmEvent["ApplicationDetailQuotationShown"] = "application.detailed-quote-shown";
  GtmEvent["ApplicationSubmitted"] = "application.submitted";
  GtmEvent["WalletPassButtonShown"] = "wallet-pass.button_shown";
  GtmEvent["WalletPassDownloadStarted"] = "wallet-pass.download_started";
  GtmEvent["WalletPassDownloadSuccess"] = "wallet-pass.download_success";
  GtmEvent["WalletPassDownloadFailed"] = "wallet-pass.download_failed";
  GtmEvent["GoogleWalletPassButtonShown"] = "google-wallet-pass.button_shown";
  GtmEvent["GoogleWalletPassSaveStarted"] = "google-wallet-pass.save_started";
  GtmEvent["GoogleWalletPassFetchStarted"] = "google-wallet-pass.fetch_started";
  GtmEvent["GoogleWalletPassFetchSuccess"] = "google-wallet-pass.fetch_success";
  GtmEvent["GoogleWalletPassFetchFailed"] = "google-wallet-pass.fetch_failed";
  GtmEvent["GoogleWalletPassUpdateLink"] = "google-wallet-pass.update_link";
  GtmEvent["QuotationInsuredTargetShown"] = "quotation.insured_target_shown";
  GtmEvent["QuotationInsuredTargetSelected"] = "quotation.insured_target_selected";
  GtmEvent["StatsigExperimentGroupAssigned"] = "statsigExperimentGroupAssigned";
  return GtmEvent;
}({});
export const dataLayer = window.dataLayer;